import React from 'react'

import clsx from 'clsx'

import { Tag } from '@insquad/tools'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { TagClientType } from 'src/strapi/types/tagTypes'
import { toTitleCase } from 'src/utils/string'

import s from './BlogTagsBlock.module.scss'

export type BlogTagsBlockProps = {
  tags: Array<TagClientType>
  selectedTagsNames: Array<string>
  onSelectTag: (tagName: string) => void
  onUnselectTag: (tagName: string) => void
}

export const BlogTagsBlock: React.FC<BlogTagsBlockProps> = ({
  tags,
  selectedTagsNames,
  onSelectTag,
  onUnselectTag,
}) => (
  <section className={clsx(s.BlogTagsBlock, 'container')}>
    <Typography
      variant={EnumTypographyVariants.H1}
      className={s.BlogTagsBlock__title}
    >
      Blog
    </Typography>

    <Typography
      variant={EnumTypographyVariants.H6}
      className={s.BlogTagsBlock__description}
      as="p"
    >
      Articles on recruiting strategies, tech labour market, remote work and
      much more.
    </Typography>

    <div className={s.BlogTagsBlock__tags}>
      {tags.map(({ text }, i) => {
        const isSelected = selectedTagsNames.includes(text)

        return (
          <Tag
            key={i}
            onClick={() => {
              isSelected ? onUnselectTag(text) : onSelectTag(text)
            }}
            text={toTitleCase(text)}
            isSelected={isSelected}
            className={s.BlogTagsBlock__tag}
          />
        )
      })}
    </div>
  </section>
)
